export class SmeltingMaterialPercentRecord {
    constructor({
          id= ``,
          day= ``,  
          time= ``, 
          locName = ``,
          locId = ``,
          furnaceName= `default`,
          furnaceBatch= ``, 
          coke= ``, 
          silica= ``, 
          ball= ``, 
          heavyDregs= ``, 
          serpentine= ``,
          dolomite= ``,
          reason= ``,
          operator= ``,
          principal= ``
      } = {}) {
      this.id = id;
      this.day = day;
      this.time = time;
      this.locName = locName;
      this.locId = locId;
      this.furnaceName = furnaceName;
      this.furnaceBatch = furnaceBatch;
      this.coke = coke;
      this.silica = silica;
      this.ball = ball;
      this.heavyDregs = heavyDregs;
      this.serpentine = serpentine;
      this.dolomite = dolomite;
      this.reason = reason;
      this.operator = operator;
      this.principal = principal;      
    }
  }
  export function gridFields() {
    return Object.freeze([              
        {
          key: 'day',
          label: 'lbl.basic.date',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },  
        {
          key: 'time',
          label: 'lbl.basic.datetime',
          sortable: true,
          form: {
            type: 'timepicker'
          }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          filterable: true,
          default: 'default',
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "locName", // 显示的属性的名称
              submitProp: "locName" // 提交的属性
            }
          }
        },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.locationCode',
          // uneditable: true,
          notInTable: true,
          // unlistable: true,
          // sortable: true,
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "id", // 显示的属性的名称
              submitProp: "id" // 提交的属性
            }
          }
        },          
        {
          key: 'furnaceName',
          label: 'lbl.basic.furnaceName',
          sortable: true,
          filterable: true,
          default:'default',
          form: {
            type: 'select',
            options: [
              {value:"default", text:"lbl.basic.select.one"},
              {value:"1", text:"opt.furnaceNumber1"},
              {value:"2", text:"opt.furnaceNumber2"},
              {value:"3", text:"opt.furnaceNumber3"},
              {value:"4", text:"opt.furnaceNumber4"},
              {value:"5", text:"opt.furnaceNumber5"},
              {value:"6", text:"opt.furnaceNumber6"},
          ]
          }
        },
        {
          key: 'furnaceBatch',
          label: 'lbl.basic.furnaceBatch',
          uneditable: true,
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'coke',
          label: 'lbl.smp.coke',
          sortable: true,
          form: {
            type: 'input'
          }          
        },
        {
          key: 'silica',
          label: 'lbl.smp.silica',
          sortable: true,
          form: {
            type: 'input'
          }          
        },
        {
          key: 'ball',
          label: 'lbl.smp.ball',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'heavyDregs',
          label: 'lbl.smp.heavyDregs',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'serpentine',
          label: 'lbl.smp.serpentine',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'dolomite',
          label: 'lbl.smp.dolomite',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'reason',
          label: 'lbl.smp.reason',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'operator',
          label: 'lbl.smp.operator',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'principal',
          label: 'lbl.smp.principal',
          sortable: true,
          form: {
            type: 'input'
          }         
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingMaterialPercentRecord()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.furnaceNameFilter',
    'filter.locNameFilter',
  ];
  export const filter = {
    'startTimeFilter': "",
    'endTimeFilter': "",
    'furnaceNameFilter': "default",
    'locNameFilter': "default",
  };